import styled, { css } from 'styled-components';
import { SvgIcon } from '../../../components/Icon';
import { Row } from '../../pageForm/FormUI';
import { theme } from '../../../styles/theme';
import { level1Content } from '../../../styles/shareableStyles';
import ThinDivider from '../../../components/ThinDivider';

export const dataModelerTablesEditorGridColumns =
  '90px minmax(200px, 1fr) minmax(400px, 2fr) 32px';

export const verticalWrapperStyles = css`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const DataModelerTabPanel = styled.div`
  padding: 16px;
  ${level1Content};
`;

export const VerticalWrapper = styled.div`
  ${verticalWrapperStyles};
`;

export const AddTableFormWrapper = styled(DataModelerTabPanel)`
  font-size: 12px;
  line-height: 1.5;
`;

export const FormRowActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
`;

export const SelectTableTypeWrapper = styled.div`
  flex-direction: row;
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const ButtonsRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ConfirmCancelButtonsWrapper = styled(ButtonsRowWrapper)`
  padding-top: 20px;
`;

export const CenteredDiv = styled.div`
  margin: auto;
`;

export const ActionIcon = styled(SvgIcon)`
  cursor: pointer;
`;

export const TablesListDictionaryCell = styled.div<{ $isBold: boolean }>`
  font-weight: ${({ $isBold }) => ($isBold ? '600px' : '500px')};
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;

export const TablesListDictionaryCellItem = styled.div`
  overflow-wrap: break-word;
`;

export const IconsRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  height: 16px;
  width: 28px;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

export const StyledFormUIRow = styled(Row)`
  padding: 4px 24px;
`;

export const ClickableStyledFormUIRow = styled(StyledFormUIRow)`
  cursor: pointer;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;

export const StyledActionsRow = styled.div<{ $hasSearch: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  div:last-child {
    margin-left: ${({ $hasSearch }) => ($hasSearch ? 'auto' : undefined)};
  }
`;

export const CdwTableLoaderWrapper = styled.div`
  width: 100%;
`;

export const TableExpandedHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 38px;
  margin-bottom: 16px;
`;

export const TableExpandedBackWrapper = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary800};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;

export const TableExpandedTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.83;
  color: ${theme.colors.secondary900};
`;

export const UnderTableFormContainer = styled.div`
  width: 100%;
  padding-top: 16px;
`;

export const EmptyDiv = styled.div`
  width: 100%;
  height: 100%;
  min-height: 28px;
`;

export const UnderTableHeaderDiv = styled.div<{ $isClickable?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.83;
  color: ${theme.colors.secondary900};
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  ${({ $isClickable }) =>
    $isClickable &&
    `
    cursor: pointer;
  `}
`;

export const ButtonSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const VerticalSeparatorDiv = styled(ThinDivider)`
  margin-right: 16px;
  margin-left: 16px;
`;

export const SpacedConfigurationSeparator = styled(ThinDivider)`
  margin-top: 12px;
  margin-bottom: 12px;
`;

export const ConfigurationLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`;

export const ConfigurationValue = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  display: flex;
  align-items: center;
  height: 24px;
  gap: 4px;
`;

export const GridCell = styled.div<{
  $clickable?: boolean;
  $isHeader?: boolean;
  $isEven?: boolean;
  $borders?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 0 4px;
  gap: 4px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : undefined)};
  overflow-x: clip;
  min-height: 28px;
  &:hover {
    color: ${({ $clickable }) =>
      $clickable ? theme.colors.mainBlue : undefined};
  }
  background-color: ${({ $isHeader, $isEven }) =>
    $isHeader
      ? theme.colors.tableHeader
      : $isEven
        ? theme.colors.level2
        : theme.colors.level1};
  border: ${({ $borders }) =>
    $borders ? `solid 1px ${theme.colors.border}` : undefined};
`;

export const HeaderGridCell = styled(GridCell)`
  font-weight: 600;
  color: ${theme.colors.secondary800};
`;

export const PreviewTableHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const NameWithIconWrapper = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;
